import { format as formatWithFns, getYear } from 'date-fns';

const currentYear = getYear(new Date());

interface Params {
  date: Date | string | number;
  forceYear?: boolean;
  shortMonth?: boolean;
  withTime?: boolean;
  withWeekday?: boolean;
}

export const formatDate = ({
  date,
  forceYear = false,
  shortMonth = false,
  withTime = false,
  withWeekday = false,
}: Params) => {
  const date_object = date instanceof Date ? date : new Date(date);
  const year = getYear(date_object);

  let format = shortMonth ? 'd MMM' : 'd MMMM';

  if (forceYear || year !== currentYear) {
    format += ' yyyy';
  }

  if (withTime) {
    format += ', HH:mm';
  }

  if (withWeekday) {
    format += ', EEEE';
  }

  return formatWithFns(date_object, format);
};
